// extracted by mini-css-extract-plugin
export default {"profile":"Profile_profile__X2Wf3","link":"Profile_link__MldZf","icon":"Profile_icon__ZImI6"};